import { FieldSchema } from "../../../Schema";
import { EntryTypes } from "./entryType";

/**
 * The pending review this record is waiting on.
 *
 * See {@link reviewAction}: workflow state, not equipment data.
 */
export const reviewId: FieldSchema = {
  name: "reviewId",
  dataTransform: {
    toGraphql: {
      getter: ({ entryType, reviewId }) => {
        if ([
          EntryTypes.CLUSTER_SUBEQUIPMENT,
          EntryTypes.STANDALONE_EQUIPMENT
        ].includes(entryType as EntryTypes)) {
          return reviewId;
        }
        return undefined;
      },
      fields: ["entryType", "reviewId"]
    },
  },  
  display: { displayed: false },
  grid: { displayed: false },
  form: { label: "Review id", disabled: true, displayed: false },
};
